// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","section":"App_section__5ICGn","active":"App_active__L1enj","inactive":"App_inactive__nFKty","navbar":"App_navbar__EtTKO"};